module.exports = __webpack_public_path__ + "media/images/site/erik-com-borda-c1d48ba9de7cf4cc637c1f9d23209b33.png";